import type { PaletteMode, PaletteModeId } from './types';

/**
 * Static registry of one-level command palette modes. Feature modules provide
 * mode contents by registering commands with the mode's item/sentinel tags.
 */
export const PALETTE_MODES: Record<PaletteModeId, PaletteMode> = {
  'pr-search': {
    id: 'pr-search',
    badgeLabel: 'PRs',
    inputPlaceholder: 'Search pull requests...',
    itemTag: 'pr-search',
    loadingTag: 'pr-search-loading',
    pendingTag: 'pr-search-pending',
    emptyTag: 'pr-search-empty',
    emptyMessage: 'No pull requests found.',
    triggerKeys: ['/', '#'],
    prefixRegExp: /^[/#]+/,
    rootSearch: 'pull-requests',
  },
  'pr-v2-add-reviewer': {
    id: 'pr-v2-add-reviewer',
    badgeLabel: 'Reviewers',
    inputPlaceholder: 'Add or remove reviewers...',
    itemTag: 'pr-v2-add-reviewer',
    loadingTag: 'pr-v2-add-reviewer-loading',
    emptyTag: 'pr-v2-add-reviewer-empty',
    emptyMessage: 'No people or teams found.',
    clearOnRouteChange: true,
    rootSearch: 'commands',
  },
  'pr-v2-diff-view': {
    id: 'pr-v2-diff-view',
    badgeLabel: 'Diff view',
    inputPlaceholder: 'Change how the diff looks...',
    itemTag: 'pr-v2-diff-view',
    emptyMessage: 'No diff settings found.',
    clearOnRouteChange: true,
    rootSearch: 'commands',
  },
  'inbox-snooze': {
    id: 'inbox-snooze',
    badgeLabel: 'Snooze',
    inputPlaceholder: 'Snooze until...',
    itemTag: 'inbox-snooze',
    emptyMessage: 'No snooze times found.',
    clearOnRouteChange: true,
  },
  'pr-v2-review': {
    id: 'pr-v2-review',
    badgeLabel: 'Review',
    inputPlaceholder: 'Review this pull request...',
    itemTag: 'pr-v2-review',
    emptyMessage: 'No review actions found.',
    clearOnRouteChange: true,
    rootSearch: 'commands',
    numbered: true,
  },
  'pr-v2-merge': {
    id: 'pr-v2-merge',
    badgeLabel: 'Merge',
    inputPlaceholder: 'Merge this pull request...',
    itemTag: 'pr-v2-merge',
    emptyTag: 'pr-v2-merge-empty',
    emptyMessage: 'No merge options found.',
    clearOnRouteChange: true,
    rootSearch: 'commands',
    numbered: true,
  },
  'pr-v2-compare': {
    id: 'pr-v2-compare',
    badgeLabel: 'Compare',
    inputPlaceholder: 'Compare versions...',
    itemTag: 'pr-v2-compare',
    emptyMessage: 'No versions found.',
    clearOnRouteChange: true,
    rootSearch: 'commands',
    numbered: true,
  },
  'pr-v2-files': {
    id: 'pr-v2-files',
    badgeLabel: 'Files',
    inputPlaceholder: 'Go to a file...',
    itemTag: 'pr-v2-file',
    emptyTag: 'pr-v2-file-empty',
    emptyMessage: 'No files found.',
    clearOnRouteChange: true,
  },
  'pr-v2-findings': {
    id: 'pr-v2-findings',
    badgeLabel: 'Findings',
    inputPlaceholder: 'Go to a finding...',
    itemTag: 'pr-v2-finding',
    emptyMessage: 'No matching findings.',
    clearOnRouteChange: true,
  },
};

export const PALETTE_MODE_LIST: readonly PaletteMode[] = Object.values(PALETTE_MODES);
